import React from 'react'
import classNames from 'classnames'

export default ({ children, className }) => (
  <h1 
    className={classNames({
      [className]: className,
      'h2 md-h1': true
    })}
  >
    {children}
  </h1>
)


// WEBPACK FOOTER //
// ./src/components/Title.js